export default __webpack_public_path__ + "static/media/work-step-2.816b32db.png";